import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {switchMap, take, tap, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Condominium, CondominiumPaginate, CondominiumStorage} from './condominium.types';
import {UserService} from '../../core/user/user.service';

@Injectable({
    providedIn: 'root'
})
export class CondominiumService
{
    private _condominium: BehaviorSubject<Condominium | null> = new BehaviorSubject(null);
    private _condominiums: BehaviorSubject<Condominium[] | null> = new BehaviorSubject([]);

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _userService: UserService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for condominium storage
     */
    get condominium(): CondominiumStorage {
        return JSON.parse(localStorage.getItem('condominium')) ?? '';
    }

    /**
     * Getter for condominium selected
     */
    get condominiumSelected(): number {
        return parseInt(localStorage.getItem('condominium_code'), 10) ?? null;
    }

    /**
     * Getter for condominium
     */
    get condominium$(): Observable<Condominium>
    {
        return this._condominium.asObservable();
    }

    /**
     * Getter for condominiums
     */
    get condominiums$(): Observable<Condominium[]>
    {
        return this._condominiums.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all condominiums
     */
    getAll(page: number = 1, pageSize: number = environment.pageSize, search: string = ''): Observable<CondominiumPaginate>
    {
        return this._httpClient.get<CondominiumPaginate>(`${environment.node}/condominiums?page=${page}&limit=${pageSize}&search=${search}`, {
            reportProgress: true
        }).pipe(
            tap((paginate: CondominiumPaginate) => {
                // Update condominiums
                this._condominiums.next(paginate.items);

                // Return condominiums
                return paginate;
            })
        );
    }

    /**
     * Get condominium by id
     */
    getCondominiumById(condominiumId: number): Observable<Condominium>
    {
        return this._httpClient.get<Condominium>(`${environment.node}/condominiums/${condominiumId}`, {
            reportProgress: true
        }).pipe(
            tap((condominium: Condominium) => {

                // Return condominium
                return condominium;
            })
        );
    }

    /**
     * Update condominium selected
     *
     * @param id
     */
    select(id: number): Observable<any>
    {
        return this._httpClient.post<any>(`${environment.node}/condominiums/select`, {id}, {reportProgress: true}).pipe(
            map((response) => {
                // Return the response
                return response;
            })
        );
    }

    update(id: number, condominium: Condominium): Observable<any>
    {
        return this._httpClient.patch<Condominium>(`${environment.node}/condominiums/${id}`, condominium, {reportProgress: true}).pipe(
            map((response) => {
                // Return the response
                return response;
            })
        );
    }
}
